// @flow weak

/* eslint no-console: 0 */
import React      from 'react';
import PropTypes  from 'prop-types';
import cx         from 'classnames';
import UserPanel  from './userPanel/UserPanel';
import Menu       from './menu/Menu';
import { Link } from "react-router-dom";
import './side-nav.css';

const AsideLeft = ({
  connectionStatus,
  userIsConnected,
  username,
  usertype,
  helloWord,
  userPicture,
  showPicture,
  isAnimated,
  isCollapsed,
  currentView,
  mainNavigation,
  onLogout
}) => (
  <aside className = { 
      cx({
        'no-print':          true,
        'left-side':         true,
        'aside-left--fixed': true,
        'sidebar-offcanvas': true,
        'sidebar-animated':  isAnimated,
        'collapse-left':     isCollapsed
      })
    }
    >
    {/*<div className="aside-left-new no-print left-side aside-left--fixed sidebar-offcanvas sidebar-animated">*/}
    <section className="sidebar">
      <UserPanel
        hello={helloWord}
        username={username}
        connectionStatus={connectionStatus}
        // online={userIsConnected}
      />
      <div className="row horlogeContainer dateAndTimeContainer text-center" style={{marginLeft: '0px', marginRight: '0px'}}></div>
      <div className="side-nav">
        <ul>
        {       
          mainNavigation.map(
               ({id,group,menus, linkKey},menuIdx) => {
                 if(menus && menus.length===1){
                  return (
                    <Menu
                      key={menuIdx}
                      initialCollapseState={menuIdx === 0 ? false : null}
                      headerTitle={menus[0].name}
                      headerBackColor="#283744"
                      activeView={currentView}
                      views={menus}
                      id={id}
                    />
                  );
                 } else{
                  return (
                    <Menu
                      key={menuIdx}
                      initialCollapseState={menuIdx === 0 ? false : null}
                      headerTitle={group}
                      parentMenuKey={linkKey}
                      headerBackColor="#283744"
                      activeView={currentView}
                      views={menus}
                      id={id}
                    />
                  );
                 }
                 
          })
        }
        </ul>
      </div>
      <div className="logout">
						
        <Link className="btn" to="#" onClick={onLogout}>
        <i className="glyphicon glyphicon-log-out pull-left" style={{lineHeight: '18px'}} />
				<span className="sidebar-menu__group-title" style={{fontSize: '13px', marginLeft: '5px'}}>Logout</span>
        </Link>			
						
						
			</div>
    </section>
    {/*</div>*/}
  </aside>
);

AsideLeft.propTypes = {
  isAnimated:   PropTypes.bool,
  isCollapsed:  PropTypes.bool,
  mainNavigation:     PropTypes.arrayOf(
    PropTypes.shape({
      id:     PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      group:  PropTypes.string,
      menus:  PropTypes.arrayOf(
        PropTypes.shape({
          name:       PropTypes.string.isRequired,
          linkTo:     PropTypes.string.isRequired,
          faIconName: PropTypes.string.isRequired
        })
      )
    })
  ).isRequired,
  currentView:      PropTypes.string,
  connectionStatus: PropTypes.shape({
    online:         PropTypes.string,
    disconnected:   PropTypes.string
  }),
  userIsConnected:  PropTypes.string,
  username:         PropTypes.string,
  userType:         PropTypes.string,
  userPicture:      PropTypes.any,
  showPicture:      PropTypes.bool,
  helloWord:        PropTypes.string,
  onLogout:        PropTypes.func
};

AsideLeft.defaultProps = {
  isAnimated:   false,
  isCollapsed:  false
};

export default AsideLeft;



// WEBPACK FOOTER //
// ./src/app/components/aside/asideLeft/AsideLeft.js